import React from "react";
import { QuizWrapper } from "~shared/components/QuizWrapper";
import { QuizEnterWord } from "~modules/QuizEnterWord";
import rebus from "~shared/assets/images/31/rebus31.jpg";
import { ImageRebus } from "~/shared/components/ImageRebus";

const Theme31Task2 = () => {
  return (
    <QuizWrapper
      title='Тест'
      icon='test'
      subtitle='Разгадай ребус.'
      description='Напиши отгадку в поле ниже'
      successIcon='nast-2'
    >
      <ImageRebus url={rebus} />
      <QuizEnterWord answer='Трамвай' />
    </QuizWrapper>
  );
};

export default Theme31Task2;
